export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 0;
export const RIGHT_PLANE_WIDTH = 450;
export const LEFT_PLANE_WIDTH = 500;
